module.exports = __webpack_public_path__ + "img/Circle_Important.d96ece34.svg";